module.exports = __webpack_public_path__ + "media/newstyle/images/icon-open-chart-54b769bdd8b51978d4c70fc515fe7da0.svg";